import { FormattedMessage } from 'react-intl';
import { DuplicateIcon } from '../../../assets/icons';
import s from './FacilityButton.module.scss';

interface DuplicateFacilityButtonProps {
  /** click handler function */
  onClick: () => void;
}

/**
 * Button for duplicating the facility
 */
function DuplicateFacilityButton({ onClick }: DuplicateFacilityButtonProps) {
  return (
    <button type="button" onClick={onClick} className={s.wrapper}>
      <DuplicateIcon role="presentation" focusable="false" />
      <FormattedMessage id="offerWizard.StepFacilityData.duplicate" />
    </button>
  );
}

export default DuplicateFacilityButton;
